import React, { useState } from "react";
import { Box } from "@mui/material";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

// Import section components
import ModernHeroSection from './ModernHeroSection';
import FeaturesSection from './FeaturesSection';
import ModernCTASection from './ModernCTASection';
import DepartmentsSection from './DepartmentsSection';
import PerformanceChartsSection from './PerformanceChartsSection';
import AnnouncementsSection from './AnnouncementsSection';
import HolidaysSection from './HolidaysSection';
import TopPerformersSection from './TopPerformersSection';
import NewJoinersSection from './NewJoinersSection';
import FooterSection from './FooterSection';
import FounderMessage from "../../Components/Reusable/FounderMessage";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const LandingPage = ({ onGetStartedClick }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedHolidayTab, setSelectedHolidayTab] = useState(0);

  const handleGetStarted = () => {
    if (onGetStartedClick) {
      onGetStartedClick();
    }
  };

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Modern Task Management Hero */}
      <ModernHeroSection onGetStartedClick={handleGetStarted} />

      {/* Features Section */}
      <FeaturesSection />

      {/* Modern CTA Section */}
      <ModernCTASection onGetStartedClick={handleGetStarted} />

      {/* Founder Message */}
      <FounderMessage />

      {/* Departments Section */}
      <DepartmentsSection />

      {/* Performance Charts Section */}
      <PerformanceChartsSection 
        selectedTab={selectedTab} 
        handleTabChange={handleTabChange} 
      />

      {/* Announcements Section */}
      <AnnouncementsSection />

      {/* Holidays Section */}
      <HolidaysSection 
        selectedHolidayTab={selectedHolidayTab}
        setSelectedHolidayTab={setSelectedHolidayTab}
      />

      {/* Top Performers Section */}
      <TopPerformersSection />

      {/* New Joiners Section */}
      <NewJoinersSection />

      {/* Footer */}
      <FooterSection />
    </Box>
  );
};

export default LandingPage;